export const QUERY_KEYS = {
  PRODUCT_DETAIL: 'productDetail',
}
